import React from "react";

const UnMatchIcon = ({ size = 24, className = "", active = false, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_619_54647)">
        <foreignObject x="-8.38674" y="-9.05275" width="50.1055" height="50.1055">
          <div xmlns="http://www.w3.org/1999/xhtml" style={{ backdropFilter: "blur(4.53px)", clipPath: "url(#bgblur_1_619_54647_clip_path)", height: "100%", width: "100%" }}></div>
        </foreignObject>
        <rect 
          data-figma-bg-blur-radius="9.05275" 
          x="1.16602" 
          y="0.5" 
          width="31" 
          height="31" 
          rx="11.5" 
          fill={active ? "#FF572D" : "#9EA6B2"} 
          fillOpacity="0.3" 
          stroke="url(#paint0_linear_619_54647)"
        />
        <path 
          d="M22.4609 10L10.4609 22" 
          stroke={active ? "#FF572D" : "#FF572D"} 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M10.4609 10L22.4609 22" 
          stroke={active ? "#FF572D" : "#FF572D"} 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="bgblur_1_619_54647_clip_path" transform="translate(8.38674 9.05275)">
          <rect x="1.16602" y="0.5" width="31" height="31" rx="11.5"/>
        </clipPath>
        <linearGradient id="paint0_linear_619_54647" x1="2.92486" y1="2.51674" x2="29.6738" y2="31.1176" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <clipPath id="clip0_619_54647">
          <rect width="32" height="32" fill="white" transform="translate(0.666016)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default UnMatchIcon; 